export const BlankTemplate = {
    name: 'blank',
    label: 'Blank',
    subject: "RE: Your Rebit order ${reference}",
    category: 'compulsory',
    body: "<p>Hi ${payer_first_name},</p>"
        + "<p>Regarding your recent Rebit order ${reference} …</p>"
        + "<p></p>"
        + "<p>Kind regards,<br>Rebit Support </p>"
}
